<form [formGroup]="group" id="chipFullWidthCOMP-form">
  <mat-form-field id="chipFullWidthCOMP-form-mat" class="custom-form-field" style="width: 100%">
    <mat-label>{{ field.displayName }}</mat-label>
    <mat-chip-grid
      [formControlName]="field.name"
      id="chipFullWidthCOMP-form-chip-list"
      #chipList
      aria-label="Chips selection"
    >
      <mat-chip-row
        id="chipFullWidthCOMP-form-chip"
        *ngFor="let chip of chips"
        [removable]="removable"
        (removed)="remove(chip)"
        [matTooltip]="chip.value"
      >
        {{ chip.value.length > 31 ? chip.value.substring(0, 31) + '...' : chip.value }}
        <mat-icon id="chipFullWidthCOMP-form-icon" matChipRemove *ngIf="removable" (click)="remove(chip)"
          >cancel</mat-icon
        >
      </mat-chip-row>
      <input
        matInput
        #chipInput
        [formControl]="chipCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)"
        [name]="field.name"
      />
    </mat-chip-grid>

    <mat-autocomplete id="chipFullWidthCOMP-form-auto" #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let chip of filteredChips" [id]="chip.value" [value]="chip.value">
        <span>
          {{ chip.value }}
        </span>
      </mat-option>
    </mat-autocomplete>

    <ng-container
      id="chipFullWidthCOMP-ng-container"
      *ngFor="let validation of field.validations"
      ngProjectAs="mat-error"
    >
      <mat-error
        id="chipFullWidthCOMP-form-error{{ field.name }}"
        *ngIf="group.get(field.name).hasError(validation.name)"
      >
        {{ validation.message }}
      </mat-error>
    </ng-container>
  </mat-form-field>
</form>
